module.exports = __webpack_public_path__ + "img/Group-7019.e2bf5172.svg";